if (process.env.NODE_ENV === 'production') {
  // eslint-disable-next-line global-require
  module.exports = require('./build/mgnl-service.min.js');
} else {
  // eslint-disable-next-line global-require
  module.exports = require('./build/mgnl-service.js');
}
